(function () {
  if (window.__mxpLoaded) return;
  window.__mxpLoaded = true;
  var started = false;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function init() {
    if (started) return;
    started = true;
    var root = document.querySelector('[data-mxp-root]');
    if (!root) return;

    /* ---- ギャラリー：サムネタップでメイン差替 ---- */
    var main = root.querySelector('[data-mxp-main]');
    var thumbs = [].slice.call(root.querySelectorAll('.mxp-thumb'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (main && t.getAttribute('data-full')) {
          main.removeAttribute('srcset');
          main.src = t.getAttribute('data-full');
        }
      });
    });

    /* ---- バリアント ---- */
    var dataEl = root.querySelector('[data-mxp-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-mxp-id]');
    var stockEl = root.querySelector('[data-mxp-stock]');
    var priceEls = [].slice.call(document.querySelectorAll('[data-mxp-price]'));
    var optEls = [].slice.call(document.querySelectorAll('[data-mxp-optlabel]'));
    var addBtns = [].slice.call(document.querySelectorAll('[data-mxp-add]'));
    var groups = [].slice.call(root.querySelectorAll('[data-mxp-optgroup]'));

    function selected() {
      return groups.map(function (g) {
        var on = g.querySelector('.mxp-chip.is-on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function update() {
      var sel = selected();
      var found = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && variants[i].options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) { found = variants[i]; break; }
      }
      if (!found) return;
      if (idInput) idInput.value = found.id;
      priceEls.forEach(function (e) { e.innerHTML = found.price; });
      optEls.forEach(function (e) {
        e.textContent = sel.filter(function (s) { return s; }).join(' / ');
      });
      if (stockEl) {
        var inStock  = stockEl.getAttribute('data-text-in')  || '在庫あり';
        var outStock = stockEl.getAttribute('data-text-out') || '在庫なし';
        stockEl.textContent = found.available ? inStock : outStock;
      }
      addBtns.forEach(function (b) {
        var textAdd     = b.getAttribute('data-text-add')     || 'カートに入れる';
        var textSoldout = b.getAttribute('data-text-soldout') || 'SOLD OUT';
        b.disabled      = !found.available;
        b.textContent   = found.available ? textAdd : textSoldout;
      });
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', found.id);
        history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var c = e.target.closest('.mxp-chip');
        if (!c || !g.contains(c)) return;
        [].slice.call(g.querySelectorAll('.mxp-chip')).forEach(function (x) { x.classList.remove('is-on'); });
        c.classList.add('is-on');
        update();
      });
    });

    /* ---- 数量 ---- */
    var qty = root.querySelector('[data-mxp-qty]');
    [].slice.call(root.querySelectorAll('[data-mxp-qtystep]')).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = parseInt(qty.value || '1', 10) + parseInt(b.getAttribute('data-mxp-qtystep'), 10);
        if (isNaN(n) || n < 1) n = 1;
        qty.value = n;
      });
    });

    /* ---- サイズ実寸表を見る ---- */
    var sizeLink = root.querySelector('[data-mxp-sizelink]');
    if (sizeLink) {
      sizeLink.addEventListener('click', function () {
        var t = document.getElementById('mxp-size-acc');
        if (!t) return;
        t.open = true;
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    update();
  }

  ready(init);
})();
